<template>
  <div class="grid-view">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane :label="$t('SystemMaintenance.PushServiceProviderConfiguration')" name="first">
        <div class="port-service-config">
          <div class="server-tit">
            <el-button v-if="!isEdit" type="primary" @click="isEdit=true">{{ $t('SystemMaintenance.Edit') }}</el-button>
            <el-button v-if="isEdit" type="success" @click="saveServer">{{ $t('SystemMaintenance.Save') }}</el-button>
            <el-button v-if="isEdit" type="primary" @click="clearServer">{{ $t('SystemMaintenance.Cancel') }}</el-button>
          </div>
          <div class="server-config-table">
            <strong>{{ $t('SystemMaintenance.PushContent') }}</strong>
            <div class="config-grid">
              <el-form>
                <el-form-item>
                  <span slot="label" style="color: #0000008a">{{ $t('SystemMaintenance.ShippingCompanyCargoTracking') }}</span>
                  <el-select v-model="shippingCompanyCargoTracking" :disabled="!isEdit" style="width: 200px">
                    <el-option :label="$t('SystemMaintenance.YundangNet')" value="2" />
                  </el-select>
                </el-form-item>
              </el-form>
              <el-table :data="tableData" border stripe>
                <el-table-column
                  prop="name"
                  min-width="100"
                  :label="$t('SystemMaintenance.PushServiceName')"
                />

                <el-table-column
                  prop="CNSHA"
                  width="150px"
                  :label="$t('SystemMaintenance.ShanghaiPort')"
                >
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.CNSHA" clearable :disabled="!isEdit">
                      <el-option :label="$t('BusinessIntelligence.businessIntelligenceChart.notChoose')" value="0" />
                      <el-option :label="$t('SystemMaintenance.Seabourne')" value="1" />
                      <el-option :label="$t('SystemMaintenance.YundangNet')" value="2" />
                      <el-option :label="$t('SystemMaintenance.SeaButler')" value="3" />
                      <el-option :label="$t('SystemMaintenance.FreighTower')" value="4" />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="CNNGB"
                  width="150px"
                  :label="$t('SystemMaintenance.NingboPort')"
                >
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.CNNGB" clearable :disabled="!isEdit">
                      <el-option :label="$t('BusinessIntelligence.businessIntelligenceChart.notChoose')" value="0" />
                      <el-option :label="$t('SystemMaintenance.YundangNet')" value="2" />
                      <el-option :label="$t('SystemMaintenance.SeaButler')" value="3" />
                      <el-option :label="$t('SystemMaintenance.FreighTower')" value="4" />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="CNXMN"
                  width="150px"
                  :label="$t('SystemMaintenance.XiamenPort')"
                >
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.CNXMN" clearable :disabled="!isEdit">
                      <el-option :label="$t('BusinessIntelligence.businessIntelligenceChart.notChoose')" value="0" />
                      <el-option :label="$t('SystemMaintenance.YundangNet')" value="2" />
                      <el-option :label="$t('SystemMaintenance.SeaButler')" value="3" />
                      <el-option :label="$t('SystemMaintenance.FreighTower')" value="4" />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="CNTAO"
                  width="150px"
                  :label="$t('SystemMaintenance.QingdaoPort')"
                >
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.CNTAO" clearable :disabled="!isEdit">
                      <el-option :label="$t('BusinessIntelligence.businessIntelligenceChart.notChoose')" value="0" />
                      <el-option :label="$t('SystemMaintenance.YundangNet')" value="2" />
                      <el-option :label="$t('SystemMaintenance.SeaButler')" value="3" />
                      <el-option :label="$t('SystemMaintenance.FreighTower')" value="4" />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="CNNSA"
                  width="150px"
                  :label="$t('SystemMaintenance.NanSha')"
                >
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.CNNSA" clearable :disabled="!isEdit">
                      <el-option :label="$t('BusinessIntelligence.businessIntelligenceChart.notChoose')" value="0" />
                      <el-option :label="$t('SystemMaintenance.YundangNet')" value="2" />
                      <el-option :label="$t('SystemMaintenance.SeaButler')" value="3" />
                      <el-option :label="$t('SystemMaintenance.FreighTower')" value="4" />
                    </el-select>
                  </template>
                </el-table-column>
                <!-- <el-table-column
                  prop="CNYTN"
                  width="150px"
                  label="盐田港口"
                >
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.CNYTN" clearable :disabled="!isEdit || (scope.row.name != '口岸船舶计划' ? false : true)">
                      <el-option label="云当网" value="2" />
                    </el-select>
                  </template>
                </el-table-column> -->
                <!-- <el-table-column
                  prop="CNSHK"
                  width="150px"
                  label="蛇口港口"
                >
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.CNSHK" clearable :disabled="!isEdit || (scope.row.name != '口岸船舶计划' ? false : true)">
                      <el-option label="云当网" value="2" />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="CNDCB"
                  width="150px"
                  label="大铲湾港口"
                >
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.CNDCB" clearable :disabled="!isEdit || (scope.row.name != '口岸船舶计划' ? false : true)">
                      <el-option label="云当网" value="2" />
                    </el-select>
                  </template>
                </el-table-column> -->
                <el-table-column
                  prop="CNSZX"
                  width="150px"
                  :label="$t('SystemMaintenance.ShenzhenPort')"
                >
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.CNSZX" clearable :disabled="!isEdit">
                      <el-option :label="$t('BusinessIntelligence.businessIntelligenceChart.notChoose')" value="0" />
                      <el-option :label="$t('SystemMaintenance.YundangNet')" value="2" />
                      <el-option :label="$t('SystemMaintenance.SeaButler')" value="3" />
                      <el-option :label="$t('SystemMaintenance.FreighTower')" value="4" />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="CNDLC"
                  width="150px"
                  :label="$t('SystemMaintenance.DalianPort')"
                >
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.CNDLC" clearable :disabled="!isEdit">
                      <el-option :label="$t('BusinessIntelligence.businessIntelligenceChart.notChoose')" value="0" />
                      <el-option :label="$t('SystemMaintenance.YundangNet')" value="2" />
                      <el-option :label="$t('SystemMaintenance.SeaButler')" value="3" />
                      <el-option :label="$t('SystemMaintenance.FreighTower')" value="4" />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="CNTXG"
                  width="150px"
                  :label="$t('SystemMaintenance.TianjinPort')"
                >
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.CNTXG" clearable :disabled="!isEdit">
                      <el-option :label="$t('BusinessIntelligence.businessIntelligenceChart.notChoose')" value="0" />
                      <el-option :label="$t('SystemMaintenance.YundangNet')" value="2" />
                      <el-option :label="$t('SystemMaintenance.SeaButler')" value="3" />
                      <el-option :label="$t('SystemMaintenance.FreighTower')" value="4" />
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <strong>{{ $t('SystemMaintenance.AirPushContent') }}</strong>
            <div class="config-grid">
              <el-table :data="airTableData" border stripe>
                <el-table-column
                  prop="name"
                  min-width="100"
                  :label="$t('SystemMaintenance.PushServiceName')"
                >
                  <template slot-scope="scope">
                    <div>{{ scope.row.airName }}</div>
                  </template>
                </el-table-column>

                <el-table-column
                  width="150px"
                  :label="$t('SystemMaintenance.ServiceProviders')"
                >
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.serviceProviders" :disabled="!isEdit">
                      <el-option :label="$t('SystemMaintenance.Close')" value="0" />
                      <el-option :label="$t('SystemMaintenance.FreighTower')" value="1" />
                      <el-option label="17Track" value="2" />
                      <el-option :label="$t('SystemMaintenance.YundangNet')" value="3" />
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination-wrapper">
              <cargo-pagination
                v-show="page.total>0"
                no="1000033-pagination"
                config-module="1000033"
                :total="page.total"
                :page.sync="page.pageNum"
                :limit.sync="page.pageSize"
                @pagination="getAirPortDataConfig"
              />
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('SystemMaintenance.DataPushCustomerList')" name="second">
        <div class="main-content">
          <div class="section">
            <el-form label-width="90px" label-position="right" inline style="height:100%">
              <el-form-item :label="$t('SystemMaintenance.CustomerWhitelist')">
                <cargo-advance-select
                  ref="tenantSel"
                  :select-type="selectTypeNames.TENANT"
                  :cache="false"
                  filterable
                  :custom-label="companyLabel"
                  :callback-params="{key:'relateTenantId'}"
                  callback-method-type="value"
                  :default-value="String(txtSearch)||''"
                  style="width:200px"
                  @parentCallBack="tenantIdChangeHandler"
                />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="addTenantEvent">添加</el-button>
                <el-button type="danger" style="margin-left: 5px" @click="delTenantEvent">{{ $t('SystemMaintenance.Delete') }}</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="section grid-wrapper">
            <cargo-ag-grid
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              @gridReady="params=>{gridApi=params.api;gridApi.sizeColumnsToFit()}"
            />
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('SystemMaintenance.AccountMaintenance')" name="third">
        <div class="main-content">
          <div class="section">
            <el-form label-width="90px" label-position="right" inline style="height:100%">
              <el-form-item :label="$t('CargoMsg.Cargo_Port')">
                <el-select v-model="accountData.port" style="width: 200px">
                  <el-option :label="$t('SystemMaintenance.All')" value="ALL" />
                  <el-option :label="$t('SystemMaintenance.Qingdao')" value="CNTAO" />
                  <el-option :label="$t('SystemMaintenance.Tianjin')" value="CNTXG" />
                  <el-option :label="$t('SystemMaintenance.Dalian')" value="CNDLC" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.CustomerName')">
                <el-input v-model="accountData.tenantName" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="accountFind">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
                <el-button @click="openAdd">{{ $t('CargoMsg.Cargo_NewTo') }}</el-button>
                <el-button @click="accountEdit">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
                <el-button type="danger" style="margin-left: 5px" @click="accountDelete">{{ $t('SystemMaintenance.Delete') }}</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="section grid-wrapper">
            <cargo-ag-grid
              :grid-options="gridOptionsAccount"
              :column-defs="columnDefsAccount"
              :row-data="columnDefsRowData"
              config-module="154656"
              @gridReady="params=>{gridApi2=params.api;gridApi2.sizeColumnsToFit()}"
            />
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.dialogVisible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item required>
            <span slot="label">{{ $t('CargoMsg.Cargo_Port') }}</span>
            <cargo-advance-select
              filterable
              style="width:100%;"
              :static-options="portList"
              tag-name="label"
              tag-value="value"
              :default-value="form.port"
              @parentCallBack="p=>{form.port=p.value}"
            />
          </el-form-item>
          <el-form-item required>
            <span slot="label">{{ $t('SystemMaintenance.CustomerName') }}</span>
            <cargo-advance-select
              ref="tenantSel"
              :select-type="selectTypeNames.TENANT"
              :cache="false"
              filterable
              :custom-label="companyLabel"
              :callback-params="{key:'relateTenantId'}"
              callback-method-type="value"
              :default-value="String(form.tenantId)||''"
              style="width:200px"
              @parentCallBack="p=>{form.tenantId=p.value}"
            />
          </el-form-item>
          <el-form-item required>
            <span slot="label">{{ $t('SystemMaintenance.AccountNumber') }}</span>
            <el-input v-model="form.accountNumber" style="width:100%;" />
          </el-form-item>
          <el-form-item required>
            <span slot="label">{{ $t('SystemMaintenance.Password') }}</span>
            <el-input v-model="form.password" style="width:100%;" />
          </el-form-item>
          <el-form-item required>
            <span slot="label">customid</span>
            <el-input v-model="form.customId" style="width:100%;" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.dialogVisible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import * as subscribePortPushRuleApi from '@/api/sysManage/subscribePortPushRule'
import SubscribePortPushRuleCustomerDialog from '@/views/cargo/v0/SystemMaintenance/components/SubscribePortPushRuleCustomerDialog'
import { getGridSelected } from '@/utils/agGrid'
import * as subscribePortPushApi from '@/api/sysManage/subscribePortPush'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import lodash from 'lodash'
import ColumnUtils from '@/utils/ColumnUtils'
import { MessageBox } from 'element-ui'
import lang from '@/lang'

export default {
  name: 'SubscribePortServiceView',
  components: { SubscribePortPushRuleCustomerDialog, cargoAdvanceSelect },
  data() {
    return {
      activeName: '',
      txtSearch: '',
      selectTypeNames: TYPE_NAMES,
      gridApi: null,
      gridApi2: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      gridOptionsAccount: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CustomerName'),
          field: 'name',
          width: 1000
        }
      ],
      columnDefsAccount: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Port'),
          field: 'port',
          width: 1000,
          cellRenderer: (params) => {
            if (params.value === 'CNTAO') {
              return this.$t('SystemMaintenance.Qingdao')
            } else if (params.value === 'CNTXG') {
              return this.$t('SystemMaintenance.Tianjin')
            } else if (params.value === 'CNDLC') {
              return this.$t('SystemMaintenance.Dalian')
            }
          }
        },
        {
          headerName: this.$t('SeaExport.CustomerName'),
          field: 'tenanId',
          width: 1000,
          cellRenderer: (params) => {
            return this.$store.getters.language === 'zh' ? params.data.tenantName : params.data.tenantEnName
          }
        },
        {
          headerName: this.$t('SystemMaintenance.AccountNumber'),
          field: 'accountNumber',
          width: 1000
        },
        {
          headerName: this.$t('SystemMaintenance.Password'),
          field: 'password',
          width: 1000
        },
        {
          headerName: 'customid',
          field: 'customId',
          width: 1000
        },
        {
          headerName: this.$t('FinanceManage.charge_editor'), colId: 'modifiedBy', field: 'modifiedBy', initialWidth: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_editTime'), colId: 'dateModified', field: 'dateModified', initialWidth: 180
        }
      ],
      allDataAccount: [],
      rowData: [],
      columnDefsRowData: [],
      tenants: [],
      PROPERTY_CUSTOMER_ID: null,
      CONDITION_ALL: null,
      subscribePortPushRule: null,
      subscribePortPush: null,
      pushRules: [],
      customers: [],
      ruleViewVisible: false,
      // 推送服务商配置
      tableData: [
        {
          name: '港区箱货数据',
          CNSHA: '',
          CNNGB: '',
          CNXMN: '',
          CNYTN: '',
          CNSHK: '',
          CNDCB: '',
          CNTAO: '',
          CNTXG: '',
          CNNSA: '',
          CNDLC: ''
        },
        {
          name: this.$t('SystemMaintenance.PortShipSchedule'),
          CNSHA: '',
          CNNGB: '',
          CNXMN: '',
          CNYTN: '',
          CNSHK: '',
          CNDCB: '',
          CNTAO: '',
          CNTXG: '',
          CNNSA: '',
          CNDLC: ''
        }
      ],
      airTableData: [],
      cloneTableData: [],
      actionType: 1, // 0.修改;1.新增;2.删除
      isEdit: false,
      accountData: {
        port: 'ALL',
        tenantName: ''
      },
      form: {},
      editDialog: {
        title: '',
        dialogVisible: false,
        add: true
      },
      portList: [
        {
          label: this.$t('SystemMaintenance.Qingdao'),
          value: 'CNTAO'
        },
        {
          label: this.$t('SystemMaintenance.Tianjin'),
          value: 'CNTXG'
        },
        {
          label: this.$t('SystemMaintenance.Dalian'),
          value: 'CNDLC'
        }
      ],
      page: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      shippingCompanyCargoTracking: '2'
    }
  },
  async created() {
    this.init()
    this.tenants = await getSpecificBasicData(TYPE_NAMES.TENANT)
  },
  mounted() {

  },
  methods: {
    // 选项卡切换事件
    handleClick(tab) {
      if (tab.name === 'first') {
        this.init()
      } else if (tab.name === 'second') {
        this.initializeHandler()
      } else if (tab.name === 'third') {
        this.accountFind()
      }
    },
    initializeHandler() {
      subscribePortPushRuleApi.getSubscribePortPushTenantList().then(resp => {
        this.subscribePortPushHandler(resp)
      })
    },
    subscribePortPushHandler(resp) {
      this.rowData = resp.data
    },
    companyLabel(data) {
      if (data) {
        return '[' + data.id + ']' + data.name
      }
      return ''
    },
    tenantIdChangeHandler(item) {
      this.txtSearch = item.value
    },
    addTenantEvent() {
      if (!this.txtSearch) {
        this.$message.warning(this.$t('SystemMaintenance.NoCustomerSelected'))
        return
      }
      const tenant = this.rowData.find(row => row.customerId === Number(this.txtSearch))
      if (!tenant) {
        subscribePortPushApi.saveSubscribePortPush({ customerId: Number(this.txtSearch) }).then(resp => {
          this.saveSubscribePortPushHandler(resp)
        })
      }
    },
    saveSubscribePortPushHandler(resp) {
      this.subscribePortPush = resp.data
      this.subscribePortPush.customerId = Number(this.txtSearch)
      const item = {}
      item.uuid = null
      item.pushId = this.subscribePortPush.uuid
      item.name = this.$t('SystemMaintenance.Consignor')
      item.property = 'OMS_JOB.CUSTOMER_ID'
      const expItem = {}
      expItem.condition = 'ALL'
      expItem.customers = []
      item.expression = JSON.stringify(expItem)
      item.tenantId = this.subscribePortPush.customerId
      const loading = getLoading()
      subscribePortPushRuleApi.addPushRule(item).then(resp => {
        this.saveRuleResultHandler(resp)
      }).finally(() => loading.close())
    },
    saveRuleResultHandler(resp) {
      const tenant = this.$refs.tenantSel.options.find(el => el.id === this.txtSearch)
      this.rowData.push(tenant)
      this.txtSearch = ''
    },
    // 删除客户
    delTenantEvent() {
      const selections = getGridSelected(this.gridOptions)
      if (!selections || selections.length === 0) {
        this.$message.warning('未选择客户.')
        return
      }
      const customerIds = selections.map(row => row.tenantId)
      const loading = getLoading()
      subscribePortPushApi.remove(customerIds).then(resp => {
        this.initializeHandler()
      }).finally(() => loading.close())
    },
    // 推送服务商配置
    // 初始化
    init() {
      this.tableData = [
        {
          name: '港区箱货数据',
          CNSHA: '',
          CNNGB: '',
          CNXMN: '',
          CNYTN: '',
          CNSHK: '',
          CNSZX: '',
          CNDCB: '',
          CNTAO: '',
          CNTXG: '',
          CNNSA: '',
          CNDLC: ''
        },
        {
          name: this.$t('SystemMaintenance.PortShipSchedule'),
          CNSHA: '',
          CNNGB: '',
          CNXMN: '',
          CNYTN: '',
          CNSHK: '',
          CNSZX: '',
          CNDCB: '',
          CNTAO: '',
          CNTXG: '',
          CNNSA: '',
          CNDLC: ''
        }
      ]
      const params = {}
      subscribePortPushRuleApi.queryPortConfig(params).then(res => {
        if (res.code === '0') {
          this.cloneTableData = res.data.sea || []
          res.data.sea.forEach(eve => {
            const len = parseInt(eve.pushService) - 1
            if (len < 2) {
              this.tableData[len][eve.port] = eve.dataSource
              this.tableData[len][eve.port + '_uuid'] = eve.uuid
              this.tableData[len][eve.port + '_version'] = eve.version
            }
          })
          this.cloneTableData = lodash.cloneDeep(this.tableData)
          this.$forceUpdate()
          this.activeName = 'first'
        }
      })
      // 获取空服务商配置
      this.getAirPortDataConfig()
    },
    // 推送服务商配置保存
    saveServer() {
      const param = []
      this.tableData.forEach((eve, index) => {
        for (const key in eve) {
          if (key !== 'name' && eve[key] && !key.includes('_uuid') && !key.includes('_version')) {
            param.push({
              port: key,
              dataSource: eve[key],
              pushService: parseInt(index + 1).toString()
            })
          }
        }
      })
      param.forEach(event => {
        if (event.pushService === '1') {
          if (this.cloneTableData[0][event.port]) {
            event.actionType = 0
            event.uuid = this.cloneTableData[0][event.port + '_uuid']
            event.version = this.cloneTableData[0][event.port + '_version']
          } else {
            event.actionType = 1
          }
        } else if (event.pushService === '2') {
          if (this.cloneTableData[1][event.port]) {
            event.actionType = 0
            event.uuid = this.cloneTableData[1][event.port + '_uuid']
            event.version = this.cloneTableData[1][event.port + '_version']
          } else {
            event.actionType = 1
          }
        } else if (event.pushService === '3') {
          if (this.cloneTableData[2][event.port]) {
            event.actionType = 0
            event.uuid = this.cloneTableData[2][event.port + '_uuid']
            event.version = this.cloneTableData[2][event.port + '_version']
          } else {
            event.actionType = 1
          }
        }
      })
      subscribePortPushRuleApi.saveBatch(param).then(res => {
        this.$message.success(this.$t('SystemMaintenance.SavedSuccessfully'))
        this.isEdit = false
        this.init()
      })
      // 保存空运配置
      subscribePortPushRuleApi.saveAirConfig(this.airTableData).then(res => {
      })
    },
    clearServer() {
      this.tableData = this.cloneTableData
      this.isEdit = false
    },
    accountFind() {
      const data = {
        port: this.accountData.port,
        tenantName: this.accountData.tenantName
      }
      subscribePortPushRuleApi.getPortDataServiceAccount(data).then(resp => {
        this.columnDefsRowData = resp.data
      })
    },
    openAdd() {
      this.form = {}
      this.editDialog.title = this.$t('SystemMaintenance.NewUser')
      this.editDialog.dialogVisible = true
      this.editDialog.add = true
    },
    save() {
      if (this.editDialog.add) {
        this.addSave()
      } else {
        this.editSave()
      }
    },
    addSave() {
      if (!this.notNull()) {
        return
      }
      const data = {
        port: this.form.port,
        tenantId: this.form.tenantId,
        accountNumber: this.form.accountNumber,
        password: this.form.password,
        customId: this.form.customId
      }
      subscribePortPushRuleApi.addPortDataServiceAccount(data).then(resp => {
        this.$message.success(this.$t('CargoMsg.Cargo_AddedSuccessfully'))
        this.editDialog.dialogVisible = false
        this.accountFind()
      })
    },
    accountEdit() {
      const rows = this.gridApi2.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (rows.length > 1) {
        this.$message.warning(this.$t('common.tips.hasOneOnly'))
        return
      }
      this.form = { ...rows[0] }
      this.editDialog.title = this.$t('SystemMaintenance.EditUser')
      this.editDialog.dialogVisible = true
      this.editDialog.add = false
    },
    editSave() {
      if (!this.notNull()) {
        return
      }
      const data = {
        uuid: this.form.uuid,
        port: this.form.port,
        tenantId: this.form.tenantId,
        accountNumber: this.form.accountNumber,
        password: this.form.password,
        customId: this.form.customId
      }
      subscribePortPushRuleApi.updatePortDataServiceAccount(data).then(resp => {
        this.$message.success(this.$t('Message.EditedSuccessfully'))
        this.editDialog.dialogVisible = false
        this.accountFind()
      })
    },
    async accountDelete() {
      const rows = this.gridApi2.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      await MessageBox.confirm(lang.t('SystemMaintenance.DeletePrompt'), lang.t('SystemMaintenance.Tips'), {
        confirmButtonText: lang.t('SystemMaintenance.Confirm'),
        cancelButtonText: lang.t('SystemMaintenance.Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const ids = rows.map(row => row.uuid)
        subscribePortPushRuleApi.delPortDataServiceAccount(ids).then(resp => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.accountFind()
        })
      }).catch(() => {
        return
      })
    },
    notNull() {
      if (!this.form.port) {
        this.$message.warning(this.$t('SystemMaintenance.PortNotNull'))
        return false
      }
      if (!this.form.tenantId) {
        this.$message.warning(this.$t('SystemMaintenance.CustomerNotNull'))
        return false
      }
      if (!this.form.accountNumber || this.form.accountNumber.trim() === '') {
        this.$message.warning(this.$t('SystemMaintenance.AccountNumberNotNull'))
        return false
      }
      if (!this.form.password || this.form.password.trim() === '') {
        this.$message.warning(this.$t('SystemMaintenance.PasswordNotNull'))
        return false
      }
      if (!this.form.customId || this.form.customId.trim() === '') {
        this.$message.warning(this.$t('SystemMaintenance.CustomIdNotNull'))
        return false
      }
      return true
    },
    getAirPortDataConfig() {
      subscribePortPushRuleApi.getAirPortDataConfig(this.page).then(res => {
        this.page.pageNum = res.data.pageNum
        this.page.pageSize = res.data.pageSize
        this.page.total = Number(res.data.total)
        this.airTableData = [...res.data.list]
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.grid-view{
  .el-tabs{
    flex: 1;
    .port-service-config{
      .server-tit{
        padding: 10px;
        background-color: #f0f3f8;
      }
      .server-config-table{
        height: 100%;
        box-sizing: border-box;
        padding: 10px;
        margin-top: 5px;
        background-color: #f0f3f8;
        strong{
          padding: 5px 20px 10px 20px;
          font-size: 15px;
          font-weight: normal;
          display: block;
        }
        .config-grid{
          width: 80%;
          margin-left: 30px;
          .el-table{
            // border-left: 1px solid #DCDFE6;
            border: 1px solid #DCDFE6;
            margin-bottom: 20px;
            /deep/ table{
              tr{
                th{
                  background-color: #f5f5f5;
                  color: #0000008a;
                  border-color: #DCDFE6;
                }
                td{
                  border-color: #DCDFE6;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
